import { Component, OnInit, Inject, AfterViewInit, Input, OnDestroy } from '@angular/core';
// import { CalendarComponent } from 'ng-fullcalendar';
import * as $ from 'jquery';
import 'fullcalendar';
// import {Options} from "fullcalendar";
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { PortalService } from '../services/portal.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../common/shared.service';
import { DatePipe } from '@angular/common';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../header/topnav/topnav.service';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment-timezone';


/**
 * Author: Redza Rosli
 * 
 * Date Created: March 2nd 2018
 * 
 * Description: Component class for Event Calender - /calendar
 **/
@Component({
  selector: 'gosg-eventcalendar',
  templateUrl: './eventcalendar.component.html',
  styleUrls: ['./eventcalendar.component.css']
})

export class EventCalendarComponent implements OnInit, AfterViewInit, OnDestroy{

  @Input()
  agencySel: String

  loading: boolean = false;
  searchAgencyResult(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  agencyData: any;
  isActiveList: boolean = false;
  initLoad: boolean = true;
  langChge: boolean = false;
  options: Object;
  event: any = [];
  langId = localStorage.getItem('langID');
  localeVal: string;
  languageId:any;
  mediaUrl: any = this.config.externalMediaURL +'/images/';
  lang;
  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;
  currCode: any;
  openLay: any = false;
  dataList: any;
  pageV: any;


  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  constructor(
    private pageTitle: Title,
    @Inject(APP_CONFIG) private config: AppConfig,
    private portalService:PortalService,
    private toastr: ToastrService,
    private datePipe:DatePipe,
    private topnavservice: TopnavService,
    private translate: TranslateService,
    private sharedService :SharedService
    
  ) {

    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const myLang = translate.currentLang;

      if (myLang == 'en') {
        translate.get('HOME').subscribe((res: any) => {
            this.lang = 'en';
            this.languageId = 1;
            this.localeVal = this.lang;
            this.langChge = true;
          });
        }

        if (myLang == 'ms') {
          translate.get('HOME').subscribe((res: any) => {
            this.lang = 'ms';
            this.languageId = 2;
            this.localeVal = 'ms-my';
            this.langChge = true;
        });
        // alert(this.languageId + ',' + this.localeVal)
      }

      if(this.topnavservice.flagLang){

        if(this.langChge == true) {
          this.agencySel = "";
          this.getEvents();
          this.options = this.getOptions(this.event,this.mediaUrl);
   //       $('#calendar').fullCalendar('destroy');
          $('#calendar').fullCalendar(this.options);
          this.sharedService.loadFontSizeData();
          this.sharedService.loadFontTypeData();


        }
      }

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string)=>{
          title = title + this.translate.instant('home.menu.calendar');
          this.sharedService.setTitle(title);
        }); 
      },500);

    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      setTimeout(()=> {
        $('.fc-center h2').css('font-size', this.fontSize.sizeL);
        $('.fc-day-number').css('font-size', this.fontSize.sizeS);
        $('.fc-button').css('font-size', this.fontSize.sizeS);
        $('.fc-day-header').css('font-size', this.fontSize.sizeS);
        $('.fc-content').css('font-size', this.fontSize.sizeS);
      }, 1000);
     
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
      this.fontType = data;
      $('.mat-input-placeholder').css('font-family', this.fontType);
    });
    localStorage.removeItem('getView');
  }
  

  ngOnInit() {

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
    }

    if (this.languageId == 1) {
      this.localeVal = 'en-us';
    } else {
      this.localeVal = 'ms-my';
    }

    // alert(this.initLoad + " onInit")
    // this.localeVal = 'en-us';
    //
      this.getEvents();
      $('#calendar').fullCalendar('destroy');
      $('#calendar').fullCalendar(this.getOptions(this.event,this.mediaUrl));
      
      localStorage.setItem('openLay', "false");
      this.openLay = localStorage.getItem('openLay');
      

  }

  ngAfterViewInit() {
    //$('.fc-center h2').css('font-size', this.fontSize.sizeL);
    //$('.fc-day-number').css('font-size', this.fontSize.sizeS);
    //$('.fc-button').css('font-size', this.fontSize.sizeS);
    //$('.fc-day-header').css('font-size', this.fontSize.sizeS);
    
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title + this.translate.instant('home.menu.calendar');
      this.sharedService.setTitleAndGtag(title);
    }); 

    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
  
  }

  ngOnDestroy() {
    localStorage.removeItem('openLay');
    localStorage.removeItem('currCode')
    localStorage.removeItem('getView');
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
  }

  onScroll(event){

    //
    if(event.target.scrollTop >= (event.target.scrollHeight - 250)) {
      //
      //

      let keywordVal;

      this.getSearchData(keywordVal, this.languageId, 1, this.searchAgencyResult.length+10)
      //
    }
  }

  resetSearch() {
    this.isActiveList = false;
    this.getEvents();
    $('#calendar').fullCalendar('destroy');
    $('#calendar').fullCalendar(this.getOptions(this.event,this.mediaUrl));
    // this.getModuleData(this.pageCount, this.pageSize);
  }

  getSearchData(keyword, langId?, count?, page?){

    // if(keyword != "" && keyword != null && keyword.length != null && keyword.length >= 3) {
      //
      //
      // this.isActive = true;
      this.loading = true;

    setTimeout(()=>{
      this.portalService.readPortal('agency/language/'+this.languageId, count, page, keyword).subscribe(
        data => {

        this.portalService.errorHandling(data, (function(){

          //
          //

          if(data['agencyList'].length != 0) {
              this.searchAgencyResult = data['agencyList'];

            this.isActiveList = true;
          } else {
            this.isActiveList = false;
          }
        }).bind(this));
        this.loading = false;
      },
      error => {
        this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
        this.isActiveList = false;
        this.loading = false;
  
      });
      this.loading = false;
    }, 2000);
    // } else {
    //   this.isActiveListEn = false;
    //   this.isActiveListBm = false;
    // }
  }

  getValue(aId,aName,mName, refCode){

    //
    this.agencySel = aName;
    this.isActiveList = false;

    this.getEventByAgency(aId);

    //
    $('#calendar').fullCalendar('destroy');
    $('#calendar').fullCalendar(this.getOptions(this.event,this.mediaUrl));

    //

  }

  getEvents() {
    this.initLoad = false;
    let sDate;
    let eDate;
    let sT;
    let eT;
    this.loading = true;

    this.portalService.getCalendarEvents().subscribe(data => {

      // this.sharedService.errorHandling(data, (function(){
        //
        this.dataList = data['list'];
        for(var item of data['list']) {
          //

          let body = {
            'id': null,
            'code': null,
            'title': null,
            'start': null,
            'end': null,
            'startTime': null,
            'endTime': null,
            'desc': null,
            'location': null,
            'color': null,
            'image': null,
            'organizer': null,
            'organizerEmail': null,
            'organizerAddress': null,
            'organizerUrl': null,
            'organizerFb': null,
            'organizerPhone': null,
            'agency': null,
            'ext': null
          };

          sDate = new Date(item.eventStart);
          eDate = new Date(item.eventEnd);
          sT = this.changeDateFormat(item.eventStart)
          eT = this.changeDateFormat(item.eventEnd)

        
        // console.log(sT)
        // console.log(eT)



          body.id = item.id;
          body.code = item.eventCode;

          if(sT == '12:00' && eT == '11:59')
            body.title = item.eventName;
          else
            body.title = sT.split(' ')[1]+' '+sT.split(' ')[2]+' '+item.eventName;

          if((this.formatTime(item.eventStart) == '12:00 AM' && this.formatTime(item.eventEnd) == '11:59 PM') || item.externalData == true){
            body.startTime = moment(item.eventStart).format('DD/MM/YYYY hh:mm A');
            body.endTime = moment(item.eventEnd).format('DD/MM/YYYY hh:mm A');
          }else{
            body.startTime = sT;
            body.endTime = eT;
          }

          body.start = sDate;
          body.end = eDate;
          // body.startTime = sT;
          // body.endTime = eT;
          body.ext = item.externalData;
          body.desc = item.eventDescription;
          body.location = item.eventLocation;

          if(sT.split(' ')[1] == '12:00' && eT.split(' ')[1] == '11:59') { // item.id == 420

            // console.log('All Day Event');
            
          // if(item.id == 420) { // 
            body.title = item.eventName;
            // console.log({'eventName':item.eventName});

            // console.log({'sT':sT});
            // console.log({'eT':eT});

            // console.log({'sT':sT.split(' ')[1]});
            // console.log({'eT':eT.split(' ')[1]});
          }

        
          if(item.agency)
            body.agency = item.agency.agencyName;

          // ORGANIZER DETAILS
          body.organizer = item.organizer;
          body.organizerEmail = item.organizerEmail;
          body.organizerAddress = item.organizerAddress;
          body.organizerUrl = item.organizerUrl;
          body.organizerFb = item.organizerFb;
          body.organizerPhone = item.organizerPhone;

          if(item.externalData == true) {
            body.color = '#0aaaaa';
            body.image = null;
            // alert(item.image.mediaFile)
          } else {
            if(item.image)
              body.image = item.image.mediaFile;
          }
          //   body.color = '#7e9e00';

          this.event.push(body)
        }
        //
        this.event = [];
        this.loading = false;

      // });
      
        this.openLay = localStorage.getItem('openLay');
        this.currCode = localStorage.getItem('currCode');
        this.pageV = localStorage.getItem('getView');
        console.log({'getEvents openLay':this.openLay});


        if(this.openLay == "true"){
          this.currentScreen(this.currCode,this.mediaUrl);
        }
    });
  }

  getEventByAgency(aId) {
    this.initLoad = true;
    let sDate;
    let eDate;
    let sT;
    let eT;
    this.loading = true;


    this.portalService.getCalendarEventsByAgencyID(aId).subscribe(data => {

      // this.sharedService.errorHandling(data, (function(){
        //
        for(var item of data['list']) {
          //

          let body = {
            'id': null,
            'code': null,
            'title': null,
            'start': null,
            'end': null,
            'startTime': null,
            'endTime': null,
            'desc': null,
            'location': null,
            'color': null,
            'image': null,
            'organizer': null,
            'organizerEmail': null,
            'organizerAddress': null,
            'organizerUrl': null,
            'organizerFb': null,
            'organizerPhone': null,
            'agency': null,
            'ext': null
          };

          sDate = new Date(item.eventStart);
          eDate = new Date(item.eventEnd);
          sT = this.changeDateFormat(item.eventStart)
          eT = this.changeDateFormat(item.eventEnd)

       
          // console.log(sT)
          // console.log(eT)


          if(sT == '12:00' && eT == '11:59')
            body.title = item.eventName;
          else
            body.title = sT.split(' ')[1]+' '+sT.split(' ')[2]+' '+item.eventName;

          body.id = item.id;
          body.code = item.eventCode;
          // body.title = sT.split(' ')[1]+' '+sT.split(' ')[2]+' '+item.eventName;
          body.start = sDate;
          body.end = eDate;
          // body.startTime = sT;
          // body.endTime = eT;
          body.ext = item.externalData;
          body.desc = item.eventDescription;
          body.location = item.eventLocation;

          if((this.formatTime(item.eventStart) == '12:00 AM' && this.formatTime(item.eventEnd) == '11:59 PM') || item.externalData == true){
            body.startTime = moment(item.eventStart).format('DD/MM/YYYY hh:mm A');
            body.endTime = moment(item.eventEnd).format('DD/MM/YYYY hh:mm A');
          }else{
            body.startTime = sT;
            body.endTime = eT;
          }


          if(item.agency)
            body.agency = item.agency.agencyName;

          // ORGANIZER DETAILS
          body.organizer = item.organizer;
          body.organizerEmail = item.organizerEmail;
          body.organizerAddress = item.organizerAddress;
          body.organizerUrl = item.organizerUrl;
          body.organizerFb = item.organizerFb;
          body.organizerPhone = item.organizerPhone;

          if(item.externalData == true) {
            body.color = '#0aaaaa';
            body.image = null;
          } else {
            if(item.image)
              body.image = item.image.mediaFile;
          }
          //   body.color = '#7e9e00';

          this.event.push(body)
        }
        //
        this.event = [];
        this.loading = false;

      // });
    },
    error => {
      this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
      this.loading = false;

    });
  }

  getOptions(calEvent, mediaPath) {

    
    let textD =  this.translate.instant('calendar.details.allday');
    

    setTimeout(()=>{

      this.options = {
        locale: this.localeVal,
        editable: false,
        displayEventTime : false,
        eventLimit: false,
        header: {
          left: 'prev,next today',
          center: 'title',
          right: null
          //  right: 'month,agendaWeek,agendaDay,listMonth'
        },
        eventAfterAllRender: function(view) {
          //console.log('All Render');
          // console.log({"view":view});
        },
        viewRender: function (view, element) {

        //  let setV = $('#calendar').fullCalendar('getView');
          localStorage.setItem('getView',view.intervalStart);
          this.pageV = view.intervalStart.format('DD-MM-YYYY');
          console.log('viewRender pageV', this.pageV);
          //console.log(view.intervalStart.format('DD-MM-YYYY'));
          //$('#calendar').fullCalendar('removeEvents');
          //$('#calendar').fullCalendar('addEventSource', calEvent);
          //$('#calendar').fullCalendar('rerenderEvents');
        },

        events: calEvent,
        firstDay: 0,
        eventClick: function(events) {
          

          console.log({'events':events});
          localStorage.setItem('currCode', events.code);
          this.currCode = localStorage.getItem('currCode');
          console.log({'eventClick currCode':this.currCode});

          localStorage.setItem('openLay', "true");
          this.openLay = localStorage.getItem('openLay');
          console.log({'eventClick openLay':this.openLay});
        


        if(events.ext == true)
          $('#titleHeader').css({'background': '#0aaaaa','border-radius':'6px 6px 0px 0px', 'border-bottom':'1px #666 solid'});
        else
          $('#titleHeader').css({'background': '#3a87ad','border-radius':'6px 6px 0px 0px', 'border-bottom':'1px #333 solid'});

        // if(events.title.split(' ').length == 3){
        //   $('#title').html(events.title.split(' ')[2]);
        // }else
        //   $('#title').html(events.title);
          
        $('#title').html(events.title);
        $('#loc').html(events.location);
        // $('#start').html(events.startTime);
        // $('#end').html(events.endTime);
        $('#desc').html(events.desc);
        $('#organizer').html(events.organizer?events.organizer:'-');
        $('#organizerEmail').html(events.organizerEmail?events.organizerEmail:'-');
        $('#organizerAddress').html(events.organizerAddress?events.organizerAddress:'-');
        $('#organizerUrl').html(events.organizerUrl?events.organizerUrl:'-');
        $('#organizerFb').html(events.organizerFb?events.organizerFb:'-');
        $('#organizerPhone').html(events.organizerPhone?events.organizerPhone:'-');
        $('#agency').html(events.agency?events.agency:'-');

        let avt = events.startTime.split(' ')[1]+' '+events.startTime.split(' ')[2];
        let avb = events.endTime.split(' ')[1]+' '+events.endTime.split(' ')[2];
        let fvt =  events.startTime.split(' ')[0];

        // console.log(avt);
        // console.log(avb);
        // console.log(fvt);
        
        if((avt == '12:00 AM' && avb == '11:59 PM') && events.ext == true){
          $('#EDate').html(fvt+'&nbsp' +  textD);
          $('#EDate').show();
          // $('#start').hide();
          // $('#end').hide();
          $('#notexr').hide();
          $('#exr').show();
        }else if (events.ext == true){
          $('#start').html(events.startTime);
          $('#end').html(events.endTime);
          $('#start').show();
          $('#end').show();
          // $('#EDate').hide();
          $('#notexr').show();
          $('#exr').hide();
        }
        else if(events.ext == false){
          $('#start').html(events.startTime);
          $('#end').html(events.endTime);
          $('#start').show();
          $('#end').show();
          // $('#EDate').hide();
          $('#notexr').show();
          $('#exr').hide();
          
        }

       
       
        // console.log(events.startTime);
        // console.log(events.endTime);

        if(events.image && !events.ext ) {
          // alert(events.title)
          $("#imageContainer").css('display','block');
          $("#eventImage").attr("src", mediaPath+events.image);
        } else {
          $("#imageContainer").css('display','none');
        }

        $('#details').css('display','block');
        $('.overlay').css('display','block');
        
        window.scrollTo(0, 0);

        //
      },
      eventMouseover: function(events) {
        $('.fc-event').attr('title', events.title);
      },
      buttonText: {
        today: this.translate.instant('calendar.view.today')
      },
      timeFormat: 'hh:mm a'

    };
   

    $('#calendar').fullCalendar('destroy');
    $('#calendar').fullCalendar(this.options);

    if(this.pageV){
      let newDate = new Date(this.pageV);
      console.log('viewRender2 pageV', newDate);
    $('#calendar').fullCalendar('gotoDate',newDate); 
    }
    // }
      // $(''
      //   +''+this.translate.instant('')+''
      //   +''+this.translate.instant()+'</div>'
      //   +''+this.translate.instant()+'</div>'
      //   +'</div>').insertAfter($('.fc-view-container'));
    }, 1000);

    return this.options;
  }

  closePopup() {
    $('#details').css('display','none');
    $('.overlay').css('display','none');
    localStorage.setItem('openLay', "false");
    localStorage.setItem('getView', this.pageV);
  }

  changeDateFormat(dateVal) {
    let res;
    res = this.datePipe.transform(dateVal, 'dd/MM/yyyy h:mm a')

    return res;
  }
  // transform(value: string) {
  //   let datePipe = new DatePipe("en-US");
  //    value = datePipe.transform(value, 'dd/MM/yyyy hh:mm a');
  //    return value;
  // }

  // updateEvent(event) {
  //   return $(this.element.nativeElement).fullCalendar('updateEvent', event);
  // }

  // clientEvents(idOrFilter) {
  //   return $(this.element.nativeElement).fullCalendar('clientEvents', idOrFilter);
  // }

  // change(changes: any) {
  //   $('#calendar').fullCalendar('changeView',changes.options.currentValue.defaultView);
  //   let locale = $('#calendar').fullCalendar('option', 'locale');
  // }

  formatTime(timestamp) {
    var d = new Date(timestamp),	// Convert the passed timestamp to milliseconds
      yyyy = d.getFullYear(),
      mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
      dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
      hh = d.getHours(),
      h = hh,
      min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
      ampm = 'AM',
      time;
        
    if (hh > 12) {
      h = hh - 12;
      ampm = 'PM';
    } else if (hh === 12) {
      h = 12;
      ampm = 'PM';
    } else if (hh == 0) {
      h = 12;
    }
    	
    time = h + ':' + min + ' ' + ampm;  
    return time;
  }

  currentScreen(code,mediaPath){

    let sDate;
    let eDate;
    let sT;
    let eT;
    let startTime;
    let endTime;
    let title;
    let match;

    let textD =  this.translate.instant('calendar.details.allday');

    console.log({'currentScreen currCode':code});
    console.log({'currentScreen dataList':this.dataList});
    let curCode = parseInt(code);
    //let match = this.dataList.filter(e => e.eventCode == curCode);

    for(let i=0; i<this.dataList.length; i++) {
    
      if (this.dataList[i].eventCode == curCode) {
       match= this.dataList[i];
      }
    }
    console.log(match);
    
          
          sDate = new Date(match.eventStart);
          eDate = new Date(match.eventEnd);
          sT = this.changeDateFormat(match.eventStart)
          eT = this.changeDateFormat(match.eventEnd)

          
          if(this.formatTime(match.eventStart) == '12:00 AM' && this.formatTime(match.eventEnd) == '11:59 PM'){
            title = match.eventName;
          }else
            title = sT.split(' ')[1]+' '+sT.split(' ')[2]+' '+match.eventName;
          
        $('#title').html(title);
        $('#loc').html(match.eventLocation);
        $('#desc').html(match.eventDescription);
        $('#organizer').html(match.organizer?match.organizer:'-');
        $('#organizerEmail').html(match.organizerEmail?match.organizerEmail:'-');
        $('#organizerAddress').html(match.organizerAddress?match.organizerAddress:'-');
        $('#organizerUrl').html(match.organizerUrl?match.organizerUrl:'-');
        $('#organizerFb').html(match.organizerFb?match.organizerFb:'-');
        $('#organizerPhone').html(match.organizerPhone?match.organizerPhone:'-');
       // $('#agency').html(match[0].agency?match[0].agency:'-');

        if(match.agency){
          $('#agency').html(match.agency.agencyName);
        }else{
          $('#agency').html('-');
        }


        if((this.formatTime(match.eventStart) == '12:00 AM' && this.formatTime(match.eventEnd) == '11:59 PM') || match.externalData == true){
          startTime = moment(match.eventStart).format('DD/MM/YYYY hh:mm A');
          endTime = moment(match.eventEnd).format('DD/MM/YYYY hh:mm A');
        }else{
          startTime = sT;
          endTime = eT;
        }

        // body.start = sDate;
        // body.end = eDate;

        let avt = startTime.split(' ')[1]+' '+startTime.split(' ')[2];
        let avb = endTime.split(' ')[1]+' '+endTime.split(' ')[2];
        let fvt = startTime.split(' ')[0];

        // console.log(avt);
        // console.log(avb);
        // console.log(fvt);
        
        if((avt == '12:00 AM' && avb == '11:59 PM') && match.externalData == true){
          $('#EDate').html(fvt+'&nbsp' +  textD);
          $('#EDate').show();
          // $('#start').hide();
          // $('#end').hide();
          $('#notexr').hide();
          $('#exr').show();
        }else if (match.externalData == true){
          $('#start').html(match.startTime);
          $('#end').html(match.endTime);
          $('#start').show();
          $('#end').show();
          // $('#EDate').hide();
          $('#notexr').show();
          $('#exr').hide();
        }
        else if(match.externalData == false){
          $('#start').html(match.startTime);
          $('#end').html(match.endTime);
          $('#start').show();
          $('#end').show();
          // $('#EDate').hide();
          $('#notexr').show();
          $('#exr').hide();
          
        }


        if(match.image && !match.externalData ) {
          // alert(events.title)
          $("#imageContainer").css('display','block');
          $("#eventImage").attr("src", mediaPath+match.image.mediaFile);
        } else {
          $("#imageContainer").css('display','none');
        }
 
  }


}




// WEBPACK FOOTER //
// ./src/app/eventcalendar/eventcalendar.component.ts